const React = require("react");
const { useCJDropshipping } = require("../context/CJDropshippingContext");
const { useDropshippingResource } = require("../hooks/useDropshippingResource");
const { PageHeader, LinkButton, ResourceState, StatusBadge } = require("../components/ui");
const h = React.createElement;

const DropshippingCJSignup = () => {
  const { api, t } = useCJDropshipping();
  const resource = useDropshippingResource(async () => {
    const signup = await api.getSignupInfo();
    const status = await api.getAccountStatus();
    return { ...signup, accountStatus: status.accountStatus || signup.accountStatus };
  }, [api]);
  const data = resource.data || {};
  const account = data.accountStatus || {};
  const steps = [
    {
      title: t("h_cj_signup_step_account", "Create your CJ account"),
      text: t("h_cj_signup_step_account_desc", "Register on CJ Dropshipping and confirm your account email."),
    },
    {
      title: t("h_cj_signup_step_key", "Get your API key"),
      text: t("h_cj_signup_step_key_desc", "In CJ, open Authorization and copy the API key assigned to your account."),
    },
    {
      title: t("h_cj_signup_step_connect", "Connect Elakay"),
      text: t("h_cj_signup_step_connect_desc", "Paste the key into Elakay. It is encrypted and never displayed again."),
    },
  ];
  const facts = [
    t("h_cj_signup_fact_supplier", "CJ Dropshipping is the supplier platform; Elakay does not hold its stock."),
    t("h_cj_signup_fact_products", "You choose CJ products and import them into your Elakay shop."),
    t("h_cj_signup_fact_orders", "Customer orders remain in Elakay and are sent to CJ when your API is connected."),
    t("h_cj_signup_fact_tracking", "Stock, prices, supplier orders and tracking are managed from your Elakay dashboard."),
  ];

  return h(React.Fragment, null,
    h(PageHeader, {
      title: t("h_cj_signup_title", "Start with CJ Dropshipping"),
      description: t("h_cj_signup_desc", "Follow these three steps to import CJ products and automate supplier fulfillment from Elakay."),
    }),
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: false, onRetry: resource.reload, t },
      h(React.Fragment, null,
        h("section", { className: "cjds-signup-hero" },
          h("div", { className: "cjds-row cjds-between" },
            h("div", null,
              h("h3", null, t("h_cj_signup_ready", "Your CJ setup")),
              h("p", { className: "cjds-muted" }, account.cjAccountEmail || t("h_cj_signup_no_email", "No CJ account email saved yet."))
            ),
            h(StatusBadge, { status: account.status || "not_connected", t })
          ),
          h("div", { className: "cjds-signup-actions" },
            h("a", {
              className: "cjds-btn cjds-external",
              href: data.signupUrl || "https://cjdropshipping.com/register.html",
              target: "_blank",
              rel: "noopener noreferrer",
            }, t("h_cj_create_account", "Create a CJ account"), " ↗"),
            h(LinkButton, { to: "/dropshipping/connection", variant: "secondary" }, t("h_cj_have_account", "I already have an account")),
            h(LinkButton, { to: "/dropshipping/connection" }, t("h_cj_connect_api", "Connect the API"))
          ),
          h("ul", { className: "cjds-facts" }, ...facts.map((fact) => h("li", { key: fact }, fact)))
        ),
        h("section", { className: "cjds-steps", "aria-label": t("h_cj_signup_steps", "CJ setup steps") },
          ...steps.map((step, index) => h("article", { className: "cjds-step", key: step.title },
            h("span", { className: "cjds-step-number", "aria-hidden": "true" }, index + 1),
            h("h3", null, step.title),
            h("p", { className: "cjds-muted" }, step.text)
          ))
        ),
        h("p", { className: "cjds-muted" },
          t("h_cj_signup_external_note", "Account creation takes place securely on the official CJ Dropshipping website. You return to Elakay only to connect the API key.")
        )
      )
    )
  );
};

module.exports = { DropshippingCJSignup };
